import { RenderViewImpactChartParams } from '@upright/common/renderer/component-types/types-render-view-impact-chart';
import styled from 'styled-components';
import { RenderViewComponentType } from '../../../../../../common/renderer/types';
import { NiceTextInput } from '../../../../../common/generic/components/inputs/nice-text-input';
import { useIsTeam } from '../../../../../common/generic/hooks';
import { BouSpacingLevel, fluidSpacing } from '../../../../../common/generic/layout/bou-spacing';
import { useRenderViewContext } from '../../../context';
import { useGetRenderViewComponentParamSetter } from '../../../context/component-param-setter';
import {
  ControlRoot,
  ControlRowContent,
  ControlRowContentRow,
  ControlRowLabel,
  RadioButton,
  RadioButtonsWrap,
} from '../../../controls/shared';

export const Legend = (props: { params: Pick<RenderViewImpactChartParams, 'showLegend'> }) => {
  const { params } = props;
  const { options, setOptions } = useRenderViewContext();
  const setParams = useGetRenderViewComponentParamSetter(RenderViewComponentType.IMPACT_CHART);
  const isTeam = useIsTeam();
  const legendShown = !!params.showLegend;
  const showTextEdits = isTeam;

  return (
    <ControlRoot>
      <ControlRowLabel>Legend</ControlRowLabel>
      <ControlRowContent>
        <ControlRowContentRow>
          <RadioButtonsWrap>
            <RadioButton
              checked={legendShown}
              onSelect={() => {
                setParams(curr => ({ ...curr, showLegend: true }));
              }}
              label={'Show'}
            />
            <RadioButton
              checked={!legendShown}
              onSelect={() => {
                setParams(curr => ({ ...curr, showLegend: false }));
              }}
              label={'Hide'}
            />
          </RadioButtonsWrap>
        </ControlRowContentRow>
        {showTextEdits && (
          <ControlRowContentRow>
            {options.items?.map((item, index) => {
              const otherItems = options.items?.filter(i => i.index !== item.index);
              return (
                <InputRow key={index}>
                  <ColorBox color={item.color} />
                  <NiceTextInput
                    value={item.name}
                    onChange={e => {
                      const updatedItem = { ...item, name: e.target.value };
                      const items = otherItems
                        ? [...otherItems, updatedItem].sort((a, b) => a.index - b.index)
                        : [updatedItem];
                      setOptions({ ...options, items });
                    }}
                  />
                </InputRow>
              );
            })}
          </ControlRowContentRow>
        )}
      </ControlRowContent>
    </ControlRoot>
  );
};

const InputRow = styled.div`
  display: flex;
  align-items: center;
  & + & {
    ${fluidSpacing('margin-top', BouSpacingLevel.MICRO)}
  }
`;

const ColorBox = styled.div<{ color?: string }>`
  background-color: ${props => props.color};
  width: 1.2em;
  height: 1.2em;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 10px;
  border: 2px solid ${props => props.color};
  border-radius: 50%;
`;
